<breadcrumb [items]="breadcrumb" />
<h1>Configurações</h1>

<ul class="nav nav-tabs mb-3">
    <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'versao'" (click)="activeTab = 'versao'" role="button">Versão</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'biblioteca'" (click)="activeTab = 'biblioteca'" role="button">Biblioteca</a>
    </li>
</ul>

<div [ngSwitch]="activeTab" class="px-3">
    <app-version *ngSwitchCase="'versao'" />
    <app-library *ngSwitchCase="'biblioteca'" />
</div>
